function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20.2 16.9c.2.2.2.6 0 .8L13 24.9c-.1.1-.2.2-.4.2-.1 0-.3-.1-.4-.2L1.5 14.2c-1.4-1.4-1.4-3.6 0-5L4.8 6c1.4-1.4 3.6-1.4 4.9 0l2.8 2.7L15.4 6c1.4-1.4 3.6-1.3 4.9 0l2.2 2.2c.2.2.2.6 0 .8-.2.2-.6.2-.8 0l-2.2-2.2c-.9-.9-2.4-1-3.4 0l-3.1 3c-.2.2-.5.2-.8 0L9 6.7c-1-.9-2.5-.9-3.4 0L2.3 10c-.9.9-.9 2.5 0 3.4l10.3 10.3 6.8-6.8c.2-.2.6-.2.8 0zm9.1-2.9c-.2-.2-.6-.2-.8 0l-3.4 3.4V5.8c0-.3-.2-.5-.5-.5s-.6.2-.6.5v11.6L20.6 14c-.2-.2-.6-.2-.8 0-.2.2-.2.6 0 .8l4.4 4.3c.1.1.2.2.4.2.1 0 .3-.1.4-.2l4.4-4.3c.2-.2.2-.6-.1-.8z"
})));